module.exports = __webpack_public_path__ + "img/W_Booking_white.48ce427c.png";